import useSWR, { trigger } from "swr";
import Manager from "../manager/Manager.api";
import Endpoints from "../endpoints/Endpoints.api";

const customers = (token) =>
  Manager.client(token).get(Endpoints.users.customers);
const updateCustomer = (token, values) =>
  Manager.client(token).post(Endpoints.users.updateCustomer, values);
const refreshCustomers = (token) =>
  trigger(`${Endpoints.users.customers}/${token.access}`);
const deleteCustomer = (token, id) =>
  Manager.client(token).delete(`${Endpoints.users.deleteCustomer}${id}/`);

export const UseCustomers = ({ access }) => {
  const { data, error } = useSWR(`${Endpoints.users.customers}/${access}`, () =>
    customers(access),
  );
  return {
    content: data ? data.data.data : [],
    error,
    loading: !error && !data,
    trigger: () => trigger(`${Endpoints.users.customers}/${access}`),
  };
};

export const Request = {
  updateCustomer,
  refreshCustomers,
  deleteCustomer,
};
